import { useState, useEffect, useCallback } from 'react';
import { ImageGroup } from '../../types';
import {
  getDefaultSelectionKey,
  isValidSelection,
  SectionKey,
} from '../utils/selectionUtils';

export interface UseSectionSelectionResult {
  selectedKey: SectionKey;
  handleSectionSelect: (key: SectionKey) => void;
}

export const useSectionSelection = (
  showCarrierImages: boolean,
  imageGroups: ImageGroup[],
  proNumber: string | undefined,
  showProImagesSection: boolean = true
): UseSectionSelectionResult => {
  const defaultKey = getDefaultSelectionKey(showCarrierImages);

  const [selectedKey, setSelectedKey] = useState<SectionKey>(() => defaultKey);

  useEffect(() => {
    const newDefaultKey = getDefaultSelectionKey(showCarrierImages);
    setSelectedKey(newDefaultKey);
  }, [proNumber, showCarrierImages]);

  useEffect(() => {
    const isCurrentSelectionValid = isValidSelection(
      selectedKey,
      showCarrierImages,
      imageGroups,
      showProImagesSection
    );

    if (!isCurrentSelectionValid) {
      const newDefaultKey = getDefaultSelectionKey(showCarrierImages);
      setSelectedKey(newDefaultKey);
    }
  }, [selectedKey, showCarrierImages, imageGroups, showProImagesSection]);

  const handleSectionSelect = useCallback((key: SectionKey) => {
    setSelectedKey(key);
  }, []);

  return {
    selectedKey,
    handleSectionSelect,
  };
};
